import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTeamContext } from "store/contexts/teamContext";
import EditTodoList from "../EditTodoList/EditTodoList";
import { ReactComponent as AddTask } from "assets/img/icons/add-task-light.svg";
import { useGlobalContext } from "store/contexts/globalContext";
import TodoListItemMicrosoftTeamsDialog from "components/TodoListItemMicrosoftTeamsDialog";
import ShareTodoList from "../ShareTodoList/ShareTodoList";
import UserDefaultAvatar from "assets/img/user.svg";
import { useHistory } from "react-router-dom";
import classNames from "classnames";

export default ({ todoList, index }) => {
  const { microsoftConfigureTab } = useGlobalContext();
  let history = useHistory();
  const { team } = useTeamContext();
  const [acronym, setAcronym] = useState();

  useEffect(() => {
    if (todoList !== undefined) {
      var str = todoList.name;
      var matches = str.split(" ");

      var result = matches.map((string) => string.charAt(0));

      if (result.length > 2) {
        result.splice(2, result.length - 2);
      }

      setAcronym(result.join(""));
    }
  }, [todoList]);

  const showUserProfile = (id) => {
    history.push(`/profile/${id}`);
  };

  return (
    <ul
      className={classNames({
        "todo-list-ul": true,
        sharedTodoListContainer: todoList?.is_forwarded ? true : false,
      })}
    >
      <li>
        {todoList?.is_forwarded && (
          <span className="sharedTodoList">
            <img
              style={{ cursor: "pointer" }}
              onClick={() => showUserProfile(todoList?.user?.id)}
              className="userAvatar"
              src={todoList?.user?.avatar ?? UserDefaultAvatar}
              alt={`avatar`}
            />
            Shared By {todoList?.user?.full_name} from{" "}
            {todoList?.original_todoList?.team?.name}
          </span>
        )}
        <div className="todo-list-link">
          <span className="todoListAvatar">
            <span>{acronym}</span>
          </span>
          <span className="todo-list-name">{todoList.name}</span>
        </div>
        <div className="edit-icons">
          {!todoList?.is_forwarded && (
            <ShareTodoList myteam_id={team?.id} todoList={todoList} />
          )}
          {[2, 3].includes(team.role_id) && (
            <EditTodoList todoList={todoList} team={team} />
          )}
          {!microsoftConfigureTab && (
            <Link to={`/teams/${team.id}/todo/${todoList.id}/list-task`}>
              <span className="icon-edit ms-1">
                <AddTask style={{ fill: "#a1a2a9" }} />
              </span>
            </Link>
          )}
          {microsoftConfigureTab && (
            <TodoListItemMicrosoftTeamsDialog
              listTodoId={todoList.id}
              listTeamId={team.id}
            >
              <span className="icon-edit ms-1">
                <AddTask style={{ fill: "#a1a2a9" }} />
              </span>
            </TodoListItemMicrosoftTeamsDialog>
          )}
        </div>
      </li>
    </ul>
  );
};
